<template>
  <div class="md:min-h-[83dvh] flex flex-col justify-between">
    <main id="main" class="h-pad pt-10 md:pt-0 transition-[padding] overflow-hidden">
      <RawHtml tag="h1" :html="$t('organization.index.title')" class="text-center text-5xl md:text-8xl title"/>
      <OrganizationSearch v-model="organizations" @close-grid="grid = false" @open-grid="grid = true" :grid="grid"/>
      <div ref="list">
        <Transition name="fade" mode="out-in">
          <div v-if="Object.values($app.organizations).length">
            <ul :class="['grid gap-4 mt-15 grid-cols-1 transition-[grid-template-columns] pb-20', {'md:grid-cols-2 lg:grid-cols-3': grid}]">
              <OrganizationCard :grid="grid" :organization="organization" v-for="organization in organizations"
                                :key="`organization-${organization.id}`" :width="slice_reference"
                                :is-mobile="isMobile"/>
            </ul>
          </div>
          <div v-else class="w-full h-[60dvh] flex items-center justify-center">
            <div class="loader"/>
          </div>
        </Transition>
      </div>
    </main>
    <SiteFooter/>
  </div>
</template>

<script>
import {OrganizationSearch, SiteFooter} from '@/components/blocks'
import {OrganizationCard} from '@/components/cards'
import {RawHtml} from '@/components/helpers'
import {setMeta} from '@/helpers'

export default {
  name: 'OrganizationIndex',
  components: {OrganizationSearch, OrganizationCard, RawHtml, SiteFooter},
  data() {
    return {
      grid: true,
      isMobile: false,
      organizations: [],
      slice_reference: 0
    }
  },
  methods: {
    handleResize() {
      if (this.$refs.list) {
        this.slice_reference = this.$refs.list.getBoundingClientRect().width
      }

      this.isMobile = window.innerWidth < 768

      if (this.isMobile && this.grid) {
        this.grid = false
      } else if(!this.isMobile && !this.grid) {
        this.grid = true
      }
    }
  },
  created() {
    this.$app.getOrganizations()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    setMeta({
      description: this.$t('seo.organization.index.description'),
      title: this.$t('seo.organization.index.title')
    })
  },
  unmounted() {
    window.addEventListener('resize', this.handleResize)
  }
}
</script>